<template>
  <section id="comment" class="pt-10">
    <v-row align="center" justify="center">
      <v-col cols="10">
        <v-row align="center" justify="center">
          <v-col cols="12" md="9" xl="9">
            <div class="text-center mt-4">
              <h1 class="section-title font-weight-light">Отзывы</h1>
              <h4 class="section-subtitle font-weight-light">Что наши клиенты говорят о нас</h4>
            </div>
          </v-col>
          <v-col cols="12" md="9" xl="9" class="mt-6 mb-6 section1-cards" style="padding-left: 0; padding-right: 0;">
            <v-row>
              <v-col md="4" sm="6" xs="12" xl="4" v-for="(feedback, i) in feedbacks" :key="i">
                <v-card
                    class="elevation-4 mx-auto"
                    width="100%"
                >
                  <v-card-title class="headline justify-center">
                    <v-img :eager="true" :src="feedback.img" max-width="100px"></v-img>
                  </v-card-title>
                  <v-card-text>
                    <span class="font-weight-bold" style="color:#005096;">{{ feedback.fio }}</span><br>
                    <span class="font-weight-bold"></span>
                    <v-divider class="pa-2"></v-divider>
                    {{ feedback.text }}
                  </v-card-text>
                  <v-divider></v-divider>
                  <div class="text-center mt-2 mb-5">
                    <v-rating
                        :value="5"
                        color="#005096"
                        background-color="grey darken-1"
                        empty-icon="$ratingFull"
                        hover
                    ></v-rating>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </section>
</template>

<script>
export default {
  data() {
    return {
      feedbacks: [
        {
          img: require("@/assets/feedback/1.jpg"),
          fio: 'Анастасия Максимова',
          date: '08 июня 2021',
          text: 'Хочу поблагодарить консультанта Анастасию Лапенко за активный и продуктивный подход! Без Вашей помощи, я бы не разобралась. Спасибо Вам за то, что Вы не только помогли мне решить вопрос, но и предложили несколько вариантов, позволяющих получить максимальный вычет. Спасибо Большое!',
        },
        {
          img: require("@/assets/feedback/2.png"),
          fio: 'Екатерина Иванова',
          date: '10 июня 2021',
          text: 'Спасибо за проделанную работу. Все качественно и оперативно. Не ожидала, что такой объем работы возможно выполнить в такие сжатые сроки. Планирую в следующем году покупку квартиры на мужа, вернемся к вам за вычетом обязательно.',
        },
        {
          img: require("@/assets/feedback/3.png"),
          fio: 'Артем Тулеев',
          date: '05 июня 2021',
          text: 'Получили все документы в обозначенные сроки, спасибо за быстрое реагирование и помощь с составлением декларации. Особенная благодарность менеджеру-консультанту Сергею Распертову, без вас я бы не справился. Спасибо.',
        },
        {
          img: require("@/assets/feedback/4.png"),
          fio: 'Ольга Седакова',
          date: '09 июня 2021',
          text: 'Долго не могла решиться заказать декларацию, пыталась оформить ее самостоятельно. Но оказалось, что это целый космос, нужно лет 300 разбираться в деталях налогового учета. Поэтому решила поискать помощников и нашла Налог Сервис. Ребята сделали все на уровне за более чем приемлемые деньги в более чем приемлемые сроки. Спасибо вам!',
        },
        {
          img: require("@/assets/feedback/5.png"),
          fio: 'Данила Ткаченко',
          date: '02 июля 2021',
          text: 'Сервис – высший класс. Все сделали качественно и быстро. В Налоговой документы приняли сразу, без вопросов. Вычет вернули раньше, чем я ожидал. ',
        },
        {
          img: require("@/assets/feedback/6.png"),
          fio: 'Марина Сырникова',
          date: '22 августа 2021',
          text: 'Спасибо команде Налог Сервиса за клиентоориентированный подход. Мне все очень понравилось, особенно общение с терпеливым и понимающим консультантом (к сожалению, не помню вашего имени). Я оплатила лечение и обратилась в Налог Сервис за помощью в возврате расходов на медицинские услуги и не пожалела ни минуты.',
        },
        //   {
        //   img: require("@/assets/feedback/7.png"),
        //   fio: 'Михаил Котовский',
        //   date: '15 сентября 2021',
        //   text: 'Услышал от знакомых о возможности возврата части денег за обучение. Обратился в компанию Налог Сервис за консультацией и не прогадал. Налог Сервис подготовили для меня весь пакет документов и сами направили в налоговую. Через 2 месяца вычет был у меня. Спасибо за работу!',
        // }
      ]
    };
  },
};
</script>

<style lang="scss">


</style>
